module.exports = __webpack_public_path__ + "aef9f4caabf8e6277979d2184c6cdbe1.fbx";